import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { netural400, netural50, primaryOrange } from "../../utils/colors";
import { APPLE_STORE_URL, GOOGLE_STORE_URL } from "../../utils/constants";

const DownloadAppModal = ({ show, onHide }) => {
  const [activeTab, setActiveTab] = useState("appstore");

  const qrCodeUrls = {
    appstore: "/images/app_store_qr_code.png",
    googleplay: "/images/google_store_qr_code.png",
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      contentClassName="rounded-4"
      dialogClassName="modal-dialog-centered"
    >
      <Modal.Body style={{ padding: "5%" }}>
        {/* Header */}
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
          <div>
            <h4 style={{ fontWeight: 700 }}>Download “My...” App!</h4>
            <p style={{ color: netural400, marginBottom: 0, width:"100%" }}>
              Scan QR code to download app from store.
            </p>
          </div>
           <button className="btn-close" onClick={onHide}></button>
        </div>

        {/* Tabs */}
        <div style={{ display: "flex", justifyContent: "center", marginTop: "24px" }}>
          {["appstore", "googleplay"].map((tab) => (
            <div
              key={tab}
              onClick={() => setActiveTab(tab)}
              style={{
                flex:1,
                textAlign:"center",
                paddingBottom: "8px",
                cursor: "pointer",
                fontWeight: 500,
                fontSize: 16,
                borderBottom: activeTab === tab ? `2px solid ${primaryOrange}` : `1px solid ${netural50}`,
                color: activeTab === tab ? primaryOrange : netural400,
              }}
            >
              {tab === "appstore" ? "App Store" : "Google Play"}
            </div>
          ))}
        </div>

        {/* QR Code */}
        <div style={{ display: "flex", justifyContent: "center", marginTop: "36px" }}>
          <img
            src={qrCodeUrls[activeTab]}
            alt="QR Code"
            style={{ width: 200, height: 200 }}
          />
        </div>

        {/* Store Buttons */}
         <div style={{display: "flex",gap: "30px", marginBottom: "20px",justifyContent:"center", marginTop:"36px"}}>
            <a href={APPLE_STORE_URL} target="_blank">
              <img src="/images/Frame 11.png" alt="Google Play" />
            </a>
            <a
              href={GOOGLE_STORE_URL}
              style={{ marginRight: "3%" }}
              target="_blank"
            >
              <img src="/images/Badge.png" alt="App Store" />
            </a>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default DownloadAppModal;